var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isParsedDataEmpty)?_c('div',{staticClass:"d-flex flex-column gap-3 align-items-center"},[_c('img',{attrs:{"src":require('no_data/reports.svg'),"width":"255","height":"165","alt":"no data"}}),_vm._v(" "),_c('span',[_vm._v("No data available for this chart.")])]):_c('div',[_c('MainProperties',{staticClass:"m-0"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }